// activate mobile menu link
jQuery('#mobilemenulink').click(function() {
menuOpen();
});


$(document).on("pagecreate", function(event) {
  runig(this);
      wow = new WOW(
                      {
                      boxClass:     'wow',      // default
                      animateClass: 'animated', // default
                      offset:       0,          // default
                      mobile:       true,       // default
                      live:         true        // default
                    }
                    )
                    wow.init();
});


$(document).one("pageshow", "#index", function(event) {
    
    //fix page jump
 // jQuery.mobile.silentScroll(0);
   
});


jQuery(document).one("pageshow", "#index", function(event) {
    createhomepageslider();
  
  jQuery('.product-description-wrap .customize a').click(function() {
    jQuery(this).closest('.tabs-content').prev('.tabs').children('li').first().children('a').click();
  });
  
  jQuery('#slide-228-layer-52').click(function() {
   
   //jQuery.mobile.silentScroll(jQuery('.rev_slider_wrapper').outerHeight());
    $('html, body').animate({
      scrollTop: jQuery('.frontpage-product').first().find('.tabs').offset().top - jQuery('#header').outerHeight()
    });
   jQuery('.frontpage-product').first().find('.tabs').children('li').first().next().children('a').click();
  });


});


$(document).one("pageshow", "#pageour-why", function(event) {
    createourwhyslider();
});



jQuery(document).on('pagebeforeshow', 'div#index[data-role*="page"]', function(event) {
// autoplay a video
video = jQuery('video').get()[0];
video.addEventListener('loadeddata', function() {
    video.play();
});
video.addEventListener('pause', function() {
    video.play();
});
});


jQuery(document).on("pagecreate", "#pagehelp-contact", function(event) {
  autocompletesearch();  
  helpaccordion();
});

jQuery(document).on("pagebeforeshow", "#searchfaq", function(event) {
  autocompletesearch();  
  helpaccordion();
});

jQuery(document).on("pageshow", '.template-product[data-role*="page"]', function(event) {
  helpaccordion();
});


function helpaccordion() {
 var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    jQuery(acc[i]).off('click').on('click', function(){
        jQuery(this).parent().get(0).classList.toggle("active");
  });
} 
}
function autocompletesearch() {
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  // Grabbing text input.
    
    var input = jQuery('#helpsearch');
  
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = $(this).val();
      // What's the search form?
      var form = $(this).closest('form');
      // What's the search URL?
      var searchURL = '/search?type=article&q=' + term;
      // What's the search results list?
      var resultsList = jQuery('#searchhelp-results');
      var resultsListWrap = jQuery('#searchhelp-results-wrap');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        // Saving old query.
        jQuery(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = jQuery.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsListWrap.removeClass('active');
          } else {
            // If we have results.
             var i = 0;
             var results = '';
            $.each(data.results, function(index, item) {
              // get the parent blog id
              blog_id = item.object.blog_id;
              // get blog ids of help page blogs
              var help1 = 'frequently-asked-questions';
              console.log(help1);
              if(item.bloghandle == help1) {
               i++;
               data.results_count = i;
               console.log(item);
               results += '<li><a href="' + item.url + '?view=faq">' + item.title + '</a></li>';
              }
              
              
            });        
            resultsList.html(results);
            resultsListWrap.addClass('active');
          }        
        });
      }else if(term.length < 3) {
        
        resultsListWrap.removeClass('active');
      }
    });

}
  

// createhomepage slider
function setREVStartSize(e){
				try{ var i=jQuery(window).width(),t=9999,r=0,n=0,l=0,f=0,s=0,h=0;					
					if(e.responsiveLevels&&(jQuery.each(e.responsiveLevels,function(e,f){f>i&&(t=r=f,l=e),i>f&&f>r&&(r=f,n=e)}),t>r&&(l=n)),f=e.gridheight[l]||e.gridheight[0]||e.gridheight,s=e.gridwidth[l]||e.gridwidth[0]||e.gridwidth,h=i/s,h=h>1?1:h,f=Math.round(h*f),"fullscreen"==e.sliderLayout){var u=(e.c.width(),jQuery(window).height());if(void 0!=e.fullScreenOffsetContainer){var c=e.fullScreenOffsetContainer.split(",");if (c) jQuery.each(c,function(e,i){u=jQuery(i).length>0?u-jQuery(i).outerHeight(!0):u}),e.fullScreenOffset.split("%").length>1&&void 0!=e.fullScreenOffset&&e.fullScreenOffset.length>0?u-=jQuery(window).height()*parseInt(e.fullScreenOffset,0)/100:void 0!=e.fullScreenOffset&&e.fullScreenOffset.length>0&&(u-=parseInt(e.fullScreenOffset,0))}f=u}else void 0!=e.minHeight&&f<e.minHeight&&(f=e.minHeight);e.c.closest(".rev_slider_wrapper").css({height:f})					
				}catch(d){console.log("Failure at Presize of Slider:"+d)}
			};













// createhomepage slider
function createourwhyslider() {
  		if(htmlDiv) {
							htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
						}else{
							var htmlDiv = document.createElement("div");
							htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
							document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
						}

var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}


	var htmlDivCss = ' #rev_slider_158_1_wrapper .tp-loader.spinner2{ background-color: #b7a549 !important; } ';
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}

	var htmlDivCss = unescape("%23rev_slider_158_1%20.uranus%20.tp-bullet%7B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20box-shadow%3A%200%200%200%202px%20rgba%28255%2C%20255%2C%20255%2C%200%29%3B%0A%20%20-webkit-transition%3A%20box-shadow%200.3s%20ease%3B%0A%20%20transition%3A%20box-shadow%200.3s%20ease%3B%0A%20%20background%3Atransparent%3B%0A%20%20width%3A15px%3B%0A%20%20height%3A15px%3B%0A%7D%0A%23rev_slider_158_1%20.uranus%20.tp-bullet.selected%2C%0A%23rev_slider_158_1%20.uranus%20.tp-bullet%3Ahover%20%7B%0A%20%20box-shadow%3A%200%200%200%202px%20rgba%28255%2C%20255%2C%20255%2C1%29%3B%0A%20%20border%3Anone%3B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20background%3Atransparent%3B%0A%7D%0A%0A%23rev_slider_158_1%20.uranus%20.tp-bullet-inner%20%7B%0A%20%20-webkit-transition%3A%20background-color%200.3s%20ease%2C%20-webkit-transform%200.3s%20ease%3B%0A%20%20transition%3A%20background-color%200.3s%20ease%2C%20transform%200.3s%20ease%3B%0A%20%20top%3A%200%3B%0A%20%20left%3A%200%3B%0A%20%20width%3A%20100%25%3B%0A%20%20height%3A%20100%25%3B%0A%20%20outline%3A%20none%3B%0A%20%20border-radius%3A%2050%25%3B%0A%20%20background-color%3A%20rgb%28255%2C%20255%2C%20255%29%3B%0A%20%20background-color%3A%20rgba%28255%2C%20255%2C%20255%2C%200.3%29%3B%0A%20%20text-indent%3A%20-999em%3B%0A%20%20cursor%3A%20pointer%3B%0A%20%20position%3A%20absolute%3B%0A%7D%0A%0A%23rev_slider_158_1%20.uranus%20.tp-bullet.selected%20.tp-bullet-inner%2C%0A%23rev_slider_158_1%20.uranus%20.tp-bullet%3Ahover%20.tp-bullet-inner%7B%0A%20transform%3A%20scale%280.4%29%3B%0A%20-webkit-transform%3A%20scale%280.4%29%3B%0A%20background-color%3Argb%28255%2C%20255%2C%20255%29%3B%0A%7D%0A");
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}


		setREVStartSize({c: jQuery('#rev_slider_158_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1920,1280,778,480], gridheight: [1080,800,534,728], sliderLayout: 'fullscreen', fullScreenAutoWidth:'off', fullScreenAlignForce:'off', fullScreenOffsetContainer:'#header', fullScreenOffset:''});

			
			var revapi158,
	tpj=jQuery;

		
			if(tpj("#rev_slider_158_1").revolution == undefined){
					revslider_showDoubleJqueryError("#rev_slider_158_1");
				}else{
						revapi158 = tpj("#rev_slider_158_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"fullscreen",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				keyboardNavigation:"off",
				keyboard_direction: "horizontal",
				mouseScrollNavigation:"off",
 							mouseScrollReverse:"default",
				onHoverStop:"off",
				touch:{
					touchenabled:"on",
					touchOnDesktop:"off",
					swipe_threshold: 75,
					swipe_min_touches: 50,
					swipe_direction: "vertical",
					drag_block_vertical: false
				}
				,
				bullets: {
					enable:true,
					hide_onmobile:false,
					style:"uranus",
					hide_onleave:false,
					direction:"vertical",
					h_align:"right",
					v_align:"bottom",
					h_offset:20,
					v_offset:50,
					space:5,
					tmp:'<span class="tp-bullet-inner"></span>'
				}
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1920,1280,778,480],
			gridheight:[1080,800,534,728],
			lazyType:"all",
			shadow:0,
			spinner:"spinner2",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			fullScreenAutoWidth:"off",
			fullScreenAlignForce:"off",
			fullScreenOffsetContainer: "#header",
			fullScreenOffset: "",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			}
		});
				}
  	
		
}










function createhomepageslider() {

var htmlDiv = document.getElementById("rs-plugin-settings-inline-css"); var htmlDivCss="";
				if(htmlDiv) {
					htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
				}else{
					var htmlDiv = document.createElement("div");
					htmlDiv.innerHTML = "<style>" + htmlDivCss + "</style>";
					document.getElementsByTagName("head")[0].appendChild(htmlDiv.childNodes[0]);
				}

    			var htmlDivCss = ' #rev_slider_157_1_wrapper .tp-loader.spinner2{ background-color: #d0b47e !important; } ';
					var htmlDiv = document.getElementById('rs-plugin-settings-inline-css');
					if(htmlDiv) {
						htmlDiv.innerHTML = htmlDiv.innerHTML + htmlDivCss;
					}
					else{
						var htmlDiv = document.createElement('div');
						htmlDiv.innerHTML = '<style>' + htmlDivCss + '</style>';
						document.getElementsByTagName('head')[0].appendChild(htmlDiv.childNodes[0]);
					}

  
setREVStartSize({c: jQuery('#rev_slider_157_1'), responsiveLevels: [1240,1024,778,480], gridwidth: [1903,1200,778,480], gridheight: [808,470,400,450], sliderLayout: 'auto'});


			
			setREVStartSize();
			
	var revapi157,
	tpj=jQuery;

			
		revapi157 = tpj("#rev_slider_157_1").show().revolution({
			sliderType:"standard",
			jsFileLocation:"",
			sliderLayout:"auto",
			dottedOverlay:"none",
			delay:9000,
			navigation: {
				onHoverStop:"off",
			},
			responsiveLevels:[1240,1024,778,480],
			visibilityLevels:[1240,1024,778,480],
			gridwidth:[1903,1200,778,480],
			gridheight:[808,470,400,450],
			lazyType:"all",
			shadow:0,
			spinner:"spinner2",
			stopLoop:"off",
			stopAfterLoops:-1,
			stopAtSlide:-1,
			shuffle:"off",
			autoHeight:"off",
			disableProgressBar:"on",
			hideThumbsOnMobile:"off",
			hideSliderAtLimit:0,
			hideCaptionAtLimit:0,
			hideAllCaptionAtLilmit:0,
			debugMode:false,
			fallbacks: {
				ignoreHeightChanges:"mobile",
				ignoreHeightChangesSize:0,
				simplifyAll:"off",
				nextSlideOnWindowFocus:"off",
				disableFocusListener:true,
			panZoomDisableOnMobile:"on",
			}
		});
      

      
  setTimeout(function() {
     window.homeSlider = true;  
  }, 300);
}



function menuOpen(){
    var scrollTop = window.document.body.scrollTop;
 //You can replace this with a regular menu open. I use some code that places the same menu panel on every page so that I only have to write it once, but it causes a duplicate ID of "menupanel"- hence the code that will only open #menupanel on the current active page
    jQuery('#mobilemenu').panel("open");
    window.document.body.scrollTop = scrollTop;
}



function runig($this) {
  
    // what we post swiper
        var userfeed = new Instafeed({
        get: 'user',
        userId: 2865852442,
        limit: 8,
    target: jQuery($this).find('.instafeed').get(0),
    accessToken: '2865852442.6a7999e.0dd6e8f0e0ca47709fa4ccf8939f2a94',
        resolution: 'low_resolution',               
            
        template: '<li><img alt="{{caption}}" src="{{image}}" /></li>',
            
         mock: true,
   success: function(response) {

 console.log(response.data)
  var myStringArray = response.data;
  var arrayLength = myStringArray.length;
  for (var i = 0; i < arrayLength; i++) {
    //Do something
    $.mobile.activePage.find('.instafeed').append('<li><a href="' + myStringArray[i].images.standard_resolution.url + '" data-lity><img src="' + myStringArray[i].images.thumbnail.url + '" /></a></li>');

}
}  
        });
    userfeed.run();
}


function isDomElem(obj) {
      if(obj instanceof HTMLCollection && obj.length) {
          for(var a = 0, len = obj.length; a < len; a++) {
              if(!checkInstance(obj[a])) {
                  console.log(a);
                  return false;   
              }
          }     
          return true;                
      } else {
          return checkInstance(obj);  
      }

      function checkInstance(elem) {
          if((elem instanceof jQuery && elem.length) || elem instanceof HTMLElement) {
              return true;  
          }
          return false;        
      }
}


// change menu on scroll
$(document).on("pageshow", function(event) {
    var header = $('#header').outerHeight();
    scrollheader();
    $(this).off('scroll', scrollheader).on('scroll', scrollheader);
});

function scrollheader() {
 var header = $('#header');
 var headerheight = header.outerHeight();
  if($(this).scrollTop() >= headerheight) {
   $(header).removeClass('nav-up').addClass('nav-down');
  }else{
    $(header).removeClass('nav-down').addClass('nav-up'); 
  }
}

// change body classes
$(document).on("pagebeforeshow", ".ui-page", function (event, data) {
  var eventid = event.target.id;
 
  if(eventid.indexOf('collection') != -1){
  var eventid = 'template-' + eventid.substring(0, eventid.indexOf('-'));
   }  
  var dataPrev = data.prevPage[0];
  if(typeof dataPrev != 'undefined') {
     var previd = dataPrev.id;
     if(previd.indexOf('collection') != -1){
     var previd = 'template-' + previd.substring(0, previd.indexOf('-'));   
     }  
    if(previd.indexOf('index') != -1){
    var previd = 'template-' + previd + ' index';   
    } 
    if(eventid.indexOf('index') != -1){
    var eventid = 'template-' + eventid;   
    }
      jQuery(document.body).removeClass(previd).addClass(eventid);
  }else{
   jQuery(document.body).addClass(eventid);
  }
 
});

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}




jQuery(document).foundation();